// Unobtrusive password strength cue. Scores 0–4 based on length + character variety
// and renders a slim 4-segment bar + a short helper label. Only renders once the
// user has typed at least one character.

const LABELS = ["Very short", "Weak", "Okay", "Strong", "Excellent"];
const FILL_COLORS = ["#D97C4A", "#D9A340", "#E8B84A", "#94AE29", "#20251F"];

export function scorePassword(pw = "") {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= 6) score += 1;
  if (/[a-zA-Z]/.test(pw) && /\d/.test(pw)) score += 1;
  if (/[^a-zA-Z0-9]/.test(pw)) score += 1;
  if (pw.length >= 10) score += 1;
  if (pw.length >= 14) score = Math.min(4, score + 1);
  return Math.min(4, score);
}

export default function PasswordStrength({ password = "", className = "" }) {
  if (!password) return null;
  const score = scorePassword(password);
  const label = LABELS[score];
  const fill = FILL_COLORS[score];
  const filled = score + 1; // at least one segment lit while typing
  return (
    <div className={`mt-2 ${className}`} data-testid="password-strength" aria-live="polite">
      <div className="flex gap-1.5" role="progressbar" aria-valuemin={0} aria-valuemax={4} aria-valuenow={score}>
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className="h-1 flex-1 rounded-full transition-colors"
            style={{ backgroundColor: i < filled ? fill : "#DED5C3" }}
          />
        ))}
      </div>
      <p className="mt-1.5 text-[11px] font-mono-label uppercase tracking-[0.14em]" style={{ color: score >= 3 ? "#3F674E" : "#6B6E67" }} data-testid="password-strength-label">
        {label}{score < 3 ? " · try 10+ characters with a number or symbol" : ""}
      </p>
    </div>
  );
}
